import { useQuery } from '@tanstack/react-query';
import { itemsApi } from '../api/items';

export function useItems(params: {
  authorReading?: string;
  tag?: string;
  sort?: string;
  limit?: number;
  include_inactive?: boolean;
} = {}) {
  return useQuery({
    queryKey: ['items', params],
    queryFn: () => itemsApi.list(params),
    staleTime: 5 * 60 * 1000, // 5分
  });
}
